import { Component, Input, OnInit } from '@angular/core';
import { FormGroup,FormBuilder,Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NmDatatableSettings } from '../../../../widgets/datatable/datatable.interface';
import { DataService } from '../../../../services/data.service';
import { FormService } from '../../../../services/form.service';
import { ApiService } from '../../../../services/api.service';
import * as moment from 'moment';

declare let bootbox: any;

@Component({
	selector: 'members-detail-tab-view',
	templateUrl: './tab-view.html'
})
export class MemberDetailTabView implements OnInit {

	@Input() form: FormGroup;
	@Input() id: string|number;
	public _reloadTable: boolean;

	private _partFormData = null;
	@Input()
	set partFormData(partFormData: any){
		if(partFormData){
			this.patchPartFormValue(partFormData);
		}else{
			this.partform.reset();
		}
		this._partFormData = partFormData;
	}
	get partFormData(): any{
		return this._partFormData;
	}

	public partform: FormGroup = this.formBuilder.group({
		// basic information
	  MemberTypeCode: ['',Validators.required],
	  Status: ['',Validators.required],
		EducationLevelId: ['',Validators.required],
		SchoolId: ['',Validators.required],
		SchoolYear: [''],
		Major: [''],
		has_coordination: [''],
		early_bird: [''],
		volunteer_type_id: [''],
    // volunteer_type_id: ['',Validators.required],
		MembershipYear: ['',Validators.required]
	});

	@Input()
	set reloadTable(reloadTable: boolean){
		this._reloadTable = reloadTable;

	}
	get reloadTable(): boolean{ return this._reloadTable}

	public constructor(
		private data: DataService,
		public formBuilder: FormBuilder,
		private router: Router,
		public _form: FormService,
		private api: ApiService,
		private activedRoute: ActivatedRoute
	) {

	}

	public ngOnInit() {
		this.participationSettings.ajax.url = 'member/'+this.id+'/participationtables';
		// this._form.setForm(this.partform);
	}

	public ngAfterViewInit() {
		this.form.valueChanges.subscribe(() => {
			//this._updateBuProfiles(this.form.get('partner_profiles').value);
		});
	}

	public patchPartFormValue(partFormData) {
		console.log(this.partFormData);
		this.partform.patchValue(partFormData);
	}


	public participationSettings: NmDatatableSettings = {
		modelName: 'member',
		fields: [
			{ name: 'MembershipYear', label: 'Membership Year' },
			{ name: 'SchoolId', label: 'School ID' },
			{ name: 'SchoolName', label: 'School Name (English)' },
			{ name: 'SchoolNameChinese', label: 'School Name (Chinese)' },
			{ name: 'EducationLevelId_label', label: 'Education Level' },
			{ name: 'SchoolYear', label: 'School Year' },
			{ name: 'Major', label: 'Major' },
			{ name: 'MemberTypeCode_label', label: 'Member Type' },
			{ name: 'Status_label', label: 'Status' },
			{ name: 'has_coordination_label', label: 'Teacher Coordination' },
			{ name: 'TotalParticipationYears', label: 'Total Participation Years' },
			{ name: 'early_bird_label', label: 'Early bird?' },
			{ name: 'volunteer_label', label: 'Volunteer' },
		],
		actions: [
			{ name: 'edit', icon: 'edit',  show: () => true , callback: function(id: string, data: any): void {
				this.dataService.tmpData.selectedEditPartRecord = data;
				console.log(data);
			}},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true , callback: function(id: string, data: any): void {
			bootbox.confirm('Are you sure to delete this record?', (ok) => {
				if(ok) {
					this.dataService[this.settings.modelName].participationdelete(id)
					.then(() => this.reload());
				}
			});
		}}
		],
		ajax: {
			url: 'member/undefined/participationtables'
		},
		ajaxDataMassage: (data: any[]) => {
			if (data == undefined) return [];
			return data.map(v => {

				v.id = v.ParticipationRecordId;
				v.has_coordination_label = v.has_coordination ? 'Y' : 'N';
				v.EducationLevelId_label = '';
				for(let st of this.data.shared.memberOptions['memberStatusList']){
					if(st.value == v.EducationLevelId){
						v.EducationLevelId_label = st.label;
					}
				}
				v.MemberTypeCode_label = '';
				for(let st of this.data.shared.memberOptions['memberTypes']){
					if(st.value == v.MemberTypeCode){
						v.MemberTypeCode_label = st.label;
					}
				}
				v.Status_label = '';
				for(let st of this.data.shared.memberOptions['memberStatusList']){
					if(st.value == v.Status){
						v.Status_label = st.label;
					}
				}
				if(v.early_bird == 1){
					v.early_bird_label = 'Yes';
				}else{
					v.early_bird_label = 'No';
				}
				v.volunteer_label = '';
				for(let st of this.data.shared.memberOptions['volunteerTypes']){
					if(st.value == v.volunteer_type_id){
						v.volunteer_label = st.label;
					}
				}


				return v;
			})
		}
	};

	public onBeforeSubmit(data: any): any { return data; }

		// after submit handle
		// default show bootbox and then return to previous page
		// note that default submission failure handle
		// should be the resposibility of api dependency of data.service
		// override this if special handle is required
		public onAfterSubmit(success: boolean): void {
			if(success) {
				bootbox.alert({
					message: 'success',
					callback:() => {
						this.onAfterSubmitAlertCallback();
					}
				});
				this._form.setForm(this.form);
			}
		};

		// callback for alert prompt after submit
		// override this if special handle is required
		public onAfterSubmitAlertCallback(): void {
			this.data.tmpData.selectedEditPartRecord = null;
		}

		// validation handle
		// default using form service to show error prompt
		// override this if special handle is required
		public onValidationFail(): void {
			this._form.showErrors();
		};

		// default submit handle
		// override this if special handle is required
		public onSavePartForm(): void {
			this._form.setForm(this.partform);
			let data = JSON.parse(JSON.stringify(this.partform.value)); // copy
			data.MemberId = this.id;

			if(this.onBeforeSubmit) {
				data = this.onBeforeSubmit(data);
			}
			//console.log(data);

			// stop from page
			if(data === false)
				return;

			if(this.partform.valid) {
				try {
					let promise;
					promise = this.api.sendApiRequest('post', 'member/'+this.data.tmpData.selectedEditPartRecord.ParticipationRecordId+'/participationsave', data).toPromise();


					promise
					.then(res => {
						this.onAfterSubmit(true);
					})
					.catch(err => {
						this.onAfterSubmit(false);
					});
				}
				catch(e) {
					console.error(e);
				}
			}
			else {
				this.onValidationFail();
			}
		}

		public onCancelPartForm(): void {
			this.data.tmpData.selectedEditPartRecord = null;
			this._form.setForm(this.form);
		}

}



// WEBPACK FOOTER //
// ./src/pages/members/detail/tab-view/tab-view.ts